import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app.jsx';

class TopErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  render() {
    if (this.state.error) {
      return React.createElement('div', {
        style: { padding: 24, fontFamily: 'monospace', color: '#fff', background: '#0d1117', minHeight: '100vh' }
      },
        React.createElement('h2', { style: { color: '#FF453A', marginTop: 0 } }, 'App Crash'),
        React.createElement('pre', { style: { fontSize: 12, whiteSpace: 'pre-wrap', color: '#FF9F0A', wordBreak: 'break-all' } },
          String(this.state.error?.stack || this.state.error)
        )
      );
    }
    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <TopErrorBoundary>
    <App />
  </TopErrorBoundary>
);
